// src/config.js
export const BASE_URL = 'https://malware-api-2hi1.onrender.com/api/v1';
